import React, { useContext } from "react";
import { Nav, Navbar, Image, NavDropdown } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { observer } from "mobx-react-lite";

import StoryContext from "../store/context";

const MainNavbar = observer(() => {
  const store = useContext(StoryContext);
  // console.log(store.admin)
  return (
    <Navbar bg="primary" variant="dark" expand="md">
      <Navbar.Brand as={NavLink} to="/">
        <Image src="rud.png" height={40} style={{ marginLeft: 10 }} />
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="navbarScroll" />
      {/* <Navbar.Offcanvas */}
      {/* id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel" placement="end"> */}
      <Navbar.Collapse id="navbarScroll">
        <Nav activeKey="/" className="me-auto">
          <Nav.Item>
            <Nav.Link as={NavLink} to="/">
              Головна
            </Nav.Link>
          </Nav.Item>
          {(store.admin === "supervisor" || store.admin === "admin") && (
            <NavDropdown title="Адміністрування" id="basic-nav-dropdown">
              <NavDropdown.Item as={NavLink} to="/routes">
                Маршрути
              </NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="/matrix">
                Матриця
              </NavDropdown.Item>
              {store.admin === "admin" && (
                <>
                  <NavDropdown.Item as={NavLink} to="/user">
                    Користувачі
                  </NavDropdown.Item>
                  <NavDropdown.Item as={NavLink} to="/change1c">
                    Інтеграция з 1с
                  </NavDropdown.Item>
                </>
              )}
            </NavDropdown>
          )}
          <NavDropdown title="Контроль">
            <NavDropdown.Item as={NavLink} to="/photos">
              Перегляд фотозвітів
            </NavDropdown.Item>
            {(store.admin === "admin" ||
              store.admin === "supervisor" ||
              store.admin === "merchandiser") && (
              <NavDropdown.Item as={NavLink} to="/about">
                Контроль роботи мерчендайзерів
              </NavDropdown.Item>
            )}
            {(store.admin === "admin" || store.admin === "supervisor") && (
              <NavDropdown.Item as={NavLink} to="/order">
                Закази
              </NavDropdown.Item>
            )}
          </NavDropdown>
          {store.admin === "admin" && (
            <NavDropdown title="Звіти">
              <NavDropdown.Item as={NavLink} to="/report">
                Звіт
              </NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="/reportsilpo">
                Звіт сільпо
              </NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="/reportamount">
                Звіт кількість
              </NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="/repostsalary">
                Звіт зарплата
              </NavDropdown.Item>
            </NavDropdown>
          )}
        </Nav>
      </Navbar.Collapse>
      {/* </Navbar.Offcanvas> */}
    </Navbar>
  );
});

export default MainNavbar;
